/* Keyboard support for Kalles visual swatches; Shopify variant selection stays native. */
(() => {
  function enhance(root = document) {
    root.querySelectorAll('.dtno1-pdp .t4s-swatch__option').forEach((option) => {
      const list = option.querySelector('[data-swatch-list], .t4s-swatch__list');
      if (!list || list.dataset.dtno1Accessible === 'true') return;
      const items = [...list.querySelectorAll('[data-swatch-item]')];
      if (!items.length) return;

      list.dataset.dtno1Accessible = 'true';
      list.setAttribute('role', 'radiogroup');
      const title = option.querySelector('.t4s-swatch__title')?.textContent || '';
      list.setAttribute('aria-label', title.split(':')[0].trim() || 'Product option');

      const sync = () => {
        const active = items.find((item) => item.classList.contains('is--selected')) || items.find((item) => !item.classList.contains('is--soldout'));
        items.forEach((item) => {
          const disabled = item.classList.contains('is--soldout');
          item.setAttribute('role', 'radio');
          item.setAttribute('aria-checked', String(item.classList.contains('is--selected')));
          item.setAttribute('aria-disabled', String(disabled));
          item.tabIndex = item === active && !disabled ? 0 : -1;
          item.setAttribute('aria-label', item.dataset.value || item.textContent.trim());
        });
      };

      list.addEventListener('keydown', (event) => {
        const current = event.target.closest('[data-swatch-item]');
        if (!current || !list.contains(current)) return;
        const enabled = items.filter((item) => !item.classList.contains('is--soldout'));
        if (!enabled.length) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          current.click();
          return;
        }
        const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
        const backward = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
        if (!forward && !backward) return;
        event.preventDefault();
        const index = enabled.indexOf(current);
        const next = enabled[(index + (forward ? 1 : -1) + enabled.length) % enabled.length];
        next.focus();
        next.click();
      });

      new MutationObserver(sync).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  } else {
    enhance();
  }
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
